import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { TrendingUp, Users, Code, Sparkles } from 'lucide-react';

const TeamGrid = () => {
  const credentials = [
    {
      icon: TrendingUp,
      title: 'Proven Track Record',
      description: '$100M+ in digital collectible sales across licensed NBA, NFL, and proprietary IP'
    },
    {
      icon: Users,
      title: 'Network Depth',
      description: 'Deep relationships across both digital and physical collectibles markets'
    },
    {
      icon: Code,
      title: 'Capital Experience',
      description: 'Tens of millions raised from leading investors in Web3 and collectibles'
    },
    {
      icon: Sparkles,
      title: 'Market Validation',
      description: 'Built top Whatnot channel within 6 months, demonstrating live-selling expertise'
    }
  ];

  return (
    <section id="team" className="py-16 lg:py-24">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <p className="uppercase tracking-[0.22em] text-xs text-muted-foreground mb-6">
            Team & Positioning
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold mb-6">
            Unmatched Market Position
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Our team brings together proven expertise in digital collectibles, live selling platforms, and high-value physical markets — the unique combination required to build trust infrastructure at scale.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {credentials.map((credential, index) => {
            const Icon = credential.icon;
            return (
              <motion.div
                key={credential.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="p-6 h-full hover:shadow-md transition-shadow">
                  <Icon className="h-8 w-8 mb-4 text-accent" />
                  <h3 className="text-xl font-semibold mb-3">{credential.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {credential.description}
                  </p>
                </Card>
              </motion.div>
            );
          })}
        </div>

        {/* Competitive Advantage */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Card className="p-8 bg-secondary/50">
            <h3 className="text-xl font-semibold mb-6 text-center">Why Sovereign Wins</h3>
            <div className="flex flex-wrap justify-center gap-3">
              <Badge variant="secondary" className="px-4 py-2 text-sm">
                Network First, Platform Second
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm">
                Trust Layer Ownership
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm">
                Curation as Discipline
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm">
                AI-Enhanced Authentication
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm">
                Cash-Flow Positive Network Building
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm">
                Deep Domain Expertise
              </Badge>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};

export default TeamGrid;
